// extracted by mini-css-extract-plugin
export default {"phoneInput":"CustomPhoneInput_phoneInput__QRJ-R"};